export enum VariationDebit {
    Inconnue = 0,
    Stable,
    EnAugmentation,
    EnDiminution,
    Irregulier
}
